import React from "react";

export default function DiamondsFour() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.77492 5.47382L11.4663 2.78242C11.7593 2.48958 12.2341 2.48958 12.527 2.78242L15.2164 5.47191C15.5093 5.76475 15.5093 6.23966 15.2164 6.53257L12.525 9.22393C12.2321 9.51687 11.7573 9.5169 11.4644 9.22393L8.77495 6.53457C8.48205 6.2416 8.48198 5.76675 8.77492 5.47382Z"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        d="M14.7758 11.4739L17.4672 8.78249C17.7601 8.48958 18.235 8.48962 18.5279 8.78249L21.2173 11.4719C21.5102 11.7648 21.5102 12.2397 21.2173 12.5326L18.5258 15.2239C18.233 15.5169 17.7581 15.5169 17.4653 15.2239L14.7758 12.5346C14.4828 12.2415 14.4829 11.7668 14.7758 11.4739Z"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        d="M2.77498 11.4654L5.46637 8.77402C5.75928 8.48111 6.23416 8.48115 6.52703 8.77402L9.21649 11.4635C9.50936 11.7563 9.50933 12.2312 9.21649 12.5241L6.52496 15.2154C6.23215 15.5085 5.75727 15.5084 5.4644 15.2154L2.77494 12.5261C2.48207 12.2331 2.48207 11.7583 2.77498 11.4654Z"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        d="M8.77579 17.4653L11.4672 14.774C11.7601 14.4811 12.2349 14.4811 12.5278 14.774L15.2173 17.4634C15.5101 17.7563 15.5102 18.2312 15.2173 18.524L12.5259 21.2155C12.2329 21.5084 11.7581 21.5084 11.4652 21.2154L8.77579 18.5261C8.48292 18.2331 8.48292 17.7583 8.77579 17.4653Z"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.24462 7.06489C8.24462 7.06489 7.80528 6.62555 7.80528 6.00423C7.80528 6.00423 7.80528 5.38291 8.24462 4.94357L10.936 2.25215C10.936 2.25215 11.3754 1.81281 11.9967 1.81281C11.9967 1.81281 12.618 1.81281 13.0574 2.25215L15.7468 4.94158C15.7468 4.94158 16.1861 5.38092 16.1861 6.00225C16.1861 6.00225 16.1861 6.62357 15.7468 7.0629L13.0554 9.75433C13.0554 9.75433 12.616 10.1937 11.9947 10.1937C11.9947 10.1937 11.3734 10.1937 10.9341 9.75433L8.24462 7.06489ZM9.30528 6.00423L11.9947 8.69367L14.6861 6.00224L11.9967 3.31281L9.30528 6.00423Z"
        fill="url(#paint0_linear_242_131)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2455 13.0649C14.2455 13.0649 13.8061 12.6256 13.8061 12.0042C13.8061 12.0042 13.8061 11.3829 14.2455 10.9436L16.9369 8.25215C16.9369 8.25215 17.3762 7.81281 17.9976 7.81281C17.9976 7.81281 18.6189 7.81281 19.0582 8.25215L21.7477 10.9416C21.7477 10.9416 22.187 11.3809 22.187 12.0022C22.187 12.0022 22.187 12.6236 21.7477 13.0629L19.0562 15.7543C19.0562 15.7543 18.6169 16.1937 17.9956 16.1937C17.9956 16.1937 17.3743 16.1937 16.9349 15.7543L14.2455 13.0649ZM15.3061 12.0042L17.9956 14.6937L20.687 12.0022L17.9976 9.31281L15.3061 12.0042Z"
        fill="url(#paint1_linear_242_131)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.24462 13.0564C2.24462 13.0564 1.80528 12.6171 1.80528 11.9958C1.80528 11.9958 1.80528 11.3744 2.24462 10.9351L4.93605 8.24368C4.93605 8.24368 5.37539 7.80434 5.99671 7.80434C5.99671 7.80434 6.61803 7.80434 7.05737 8.24368L9.7468 10.9331C9.7468 10.9331 10.1861 11.3725 10.1861 11.9938C10.1861 11.9938 10.1861 12.6151 9.7468 13.0544L7.05538 15.7459C7.05538 15.7459 6.61604 16.1852 5.99472 16.1852C5.99472 16.1852 5.3734 16.1852 4.93406 15.7459L2.24462 13.0564ZM3.30528 11.9958L5.99472 14.6852L8.68614 11.9938L5.99671 9.30434L3.30528 11.9958Z"
        fill="url(#paint2_linear_242_131)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.24547 19.0564C8.24547 19.0564 7.80613 18.6171 7.80613 17.9958C7.80613 17.9958 7.80613 17.3744 8.24547 16.9351L10.9369 14.2437C10.9369 14.2437 11.3762 13.8043 11.9976 13.8043C11.9976 13.8043 12.6189 13.8043 13.0582 14.2437L15.7477 16.9331C15.7477 16.9331 16.187 17.3724 16.187 17.9938C16.187 17.9938 16.187 18.6151 15.7477 19.0544L13.0562 21.7459C13.0562 21.7459 12.6169 22.1852 11.9956 22.1852C11.9956 22.1852 11.3743 22.1852 10.9349 21.7459L8.24547 19.0564ZM9.30613 17.9958L11.9956 20.6852L14.687 17.9938L11.9976 15.3043L9.30613 17.9958Z"
        fill="url(#paint3_linear_242_131)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_242_131"
          x1="11.5705"
          y1="9.72049"
          x2="14.5645"
          y2="5.19565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="0.26" stopColor="#EC281E" />
          <stop offset="0.73" stopColor="#EC480E" />
          <stop offset="1" stopColor="#EC5E04" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_242_131"
          x1="17.5713"
          y1="15.7205"
          x2="20.5653"
          y2="11.1957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="0.26" stopColor="#EC281E" />
          <stop offset="0.73" stopColor="#EC480E" />
          <stop offset="1" stopColor="#EC5E04" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_242_131"
          x1="5.57048"
          y1="15.712"
          x2="8.56447"
          y2="11.1872"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="0.26" stopColor="#EC281E" />
          <stop offset="0.73" stopColor="#EC480E" />
          <stop offset="1" stopColor="#EC5E04" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_242_131"
          x1="11.5713"
          y1="21.712"
          x2="14.5653"
          y2="17.1872"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="0.26" stopColor="#EC281E" />
          <stop offset="0.73" stopColor="#EC480E" />
          <stop offset="1" stopColor="#EC5E04" />
        </linearGradient>
      </defs>
    </svg>
  );
}
